import React from "react";

/** Table row icon action; use disabled + title when permission is missing. */
const CourierAction = ({
  title,
  iconClass,
  onClick,
  disabled,
  disabledTitle
}) => (
  <a
    href=" "
    title={disabled ? disabledTitle || title : title}
    className={`action ${iconClass}${disabled ? " courier-action-disabled" : ""}`}
    onClick={e => {
      e.preventDefault();
      if (!disabled && onClick) onClick(e);
    }}
  />
);

export default CourierAction;
